import { AutogenLayoutCarrierQualificationDetailsQuickInfo } from "./autogen/AutogenLayoutCarrierQualificationDetailsQuickInfo";

export class CarrierQualificationDetailsQuickInfo extends AutogenLayoutCarrierQualificationDetailsQuickInfo {

}
